<app-wizard-bar-nav [stepIsDirty]="this.isQuoteRequestInvalidated()"></app-wizard-bar-nav>

<div class="step-container">
  <h3>Supply Details | <em heading-info [quoteInfo]="quoteRequestState"></em></h3>
  <app-apply-to-all [dataSource]="dataSource"></app-apply-to-all>
  <section>
    <div *ngIf="generatingLoadProfileData" class="loadProfileStatusContainer">
      <em>Generating Load Profile Data..</em>
      <mat-spinner diameter="18"></mat-spinner>
    </div>
    <br>
    <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="noselect tenders-grid full-width">
      <ng-container matColumnDef="utilityAccountNumber">
        <th mat-header-cell *matHeaderCellDef>Utility Account Number</th>
        <td class="readOnlyCell" mat-cell *matCellDef="let data">
          <span>{{ data.utilityAccountNumber }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="rateCode">
        <th mat-header-cell *matHeaderCellDef>Load Profile</th>
        <td class="readOnlyCell" mat-cell *matCellDef="let data">
          <span>{{ data.rateCode }}</span>
          <span *ngIf="!data.rateCode">-</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="peakLoadContribution">
        <th mat-header-cell *matHeaderCellDef>{{ plcNsplRequirement?.plcLabel }}</th>
        <td
          class="inputCell"
          [ngStyle]="{
            color:
              (data.peakLoadContribution && data.plcLoadFactorPercentage !== 0 && data.peakLoadContribution <= 1000000) ||
              this.userIdentity.isBroker
                ? 'inherit'
                : 'red'
          }"
          mat-cell
          *matCellDef="let data"
        >
          <input matInput
                type="number"
                [(ngModel)]="data.peakLoadContribution"
                (change)="this.calculatePlcLoadFactorPercentage(data)"
                [disabled]="isReadOnly || !plcNsplRequirement.plc || ( !this.userIdentity.isSupplierManagerOrSalesManager && data.usageSource === usageSourceEnum.METER_VAULT)"
          />
          <mat-spinner
            matSuffix
            [diameter]="16"
            *ngIf="data.loadingLoadProfile"
            color="primary"
            [matTooltip]="'Fetching load profile.'"
          ></mat-spinner>
        </td>
      </ng-container>

      <ng-container *ngIf="this.userIdentity.isSupplierManagerOrSalesManager" matColumnDef="plcLoadFactorPercentage">
        <th mat-header-cell *matHeaderCellDef>{{ plcNsplRequirement?.plcLoadFactorLabel }}</th>
        <td
          class="readOnlyCell"
          [ngStyle]="{ color: !this.isPlcBelowCustomerThreshold(data) && data.plcLoadFactorPercentage && !this.maximumLoadFactorPercentageIgnored ? 'red' : 'black' }"
          mat-cell
          *matCellDef="let data"
        >
          <span *ngIf="data.plcLoadFactorPercentage > 0 && data.peakLoadContribution <= 1000000">{{
            data.plcLoadFactorPercentage | number: '1.2-2'
          }}</span>
          <span *ngIf="data.plcLoadFactorPercentage <= 0 || data.peakLoadContribution > 1000000">-</span>
        </td>
      </ng-container>

      <ng-container *ngIf="this.userIdentity.isSupplierManagerOrSalesManager" matColumnDef="plcErrors">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let data">
          <span *ngIf="!this.isPlcBelowCustomerThreshold(data) && data.plcLoadFactorPercentage">
            <mat-icon
              [class.maximumLoadFactorPercentageIgnored]="this.maximumLoadFactorPercentageIgnored ? true : false"
              color="{{ !this.maximumLoadFactorPercentageIgnored ? 'warn' : null }}"
              matTooltipPosition="right"
              data-html="true"
              matTooltipClass="enable-line-break ud-tooltip"
              [matTooltip]="getPlcFullValidationMessageStr(data)"
              (click)="showOverrideDialog(data)"
            >
              error</mat-icon
            >
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="networkServicePeakLoad">
        <th mat-header-cell *matHeaderCellDef>Network Service Peak Load (NSPL)</th>
        <td
          class="inputCell"
          [ngStyle]="{
            color:
              (data.networkServicePeakLoad && data.nsplLoadFactorPercentage !== 0 && data.networkServicePeakLoad <= 1000000) ||
              this.userIdentity.isBroker
                ? 'inherit'
                : 'red'
          }"
          mat-cell
          *matCellDef="let data"
        >
          <input matInput
                type="number"
                [(ngModel)]="data.networkServicePeakLoad"
                (change)="this.calculateNsplLoadFactorPercentage(data)"
                [disabled]="isReadOnly || !plcNsplRequirement.plc || ( !this.userIdentity.isSupplierManagerOrSalesManager && data.usageSource === usageSourceEnum.METER_VAULT)"
          />
          <mat-spinner
            matSuffix
            [diameter]="16"
            *ngIf="data.loadingLoadProfile"
            color="primary"
            [matTooltip]="'Fetching load profile.'"
          ></mat-spinner>
        </td>
      </ng-container>

      <ng-container *ngIf="this.userIdentity.isSupplierManagerOrSalesManager" matColumnDef="nsplLoadFactorPercentage">
        <th mat-header-cell *matHeaderCellDef>NSPL Load Factor (%)</th>
        <td
          class="readOnlyCell"
          [ngStyle]="{ color: !this.isNsplBelowCustomerThreshold(data) && data.nsplLoadFactorPercentage && !this.maximumLoadFactorPercentageIgnored && !this.maximumLoadFactorPercentageIgnored ? 'red' : 'black' }"
          mat-cell
          *matCellDef="let data"
        >
          <span *ngIf="data.nsplLoadFactorPercentage > 0 && data.networkServicePeakLoad <= 1000000">{{
            data.nsplLoadFactorPercentage | number: '1.2-2'
          }}</span>
          <span *ngIf="data.nsplLoadFactorPercentage <= 0 || data.networkServicePeakLoad > 1000000">-</span>
        </td>
      </ng-container>

      <ng-container *ngIf="this.userIdentity.isSupplierManagerOrSalesManager" matColumnDef="nsplErrors">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let data">
          <span *ngIf="!this.isNsplBelowCustomerThreshold(data) && data.nsplLoadFactorPercentage">
            <mat-icon
              [class.maximumLoadFactorPercentageIgnored]="this.maximumLoadFactorPercentageIgnored ? true : false"
              color="{{ !this.maximumLoadFactorPercentageIgnored ? 'warn' : null }}"
              matTooltipPosition="right"
              data-html="true"
              matTooltipClass="enable-line-break ud-tooltip"
              [matTooltip]="getNsplFullValidationMessageStr(data)"
              (click)="showOverrideDialog(data)"
            >
              error</mat-icon
            >
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="newContractStartMonth">
        <th mat-header-cell *matHeaderCellDef>New Contract Start Month</th>
        <td class="readOnlyCell" mat-cell *matCellDef="let data">
          <span>{{ data.newContractStartDate | date: 'MMM-yyyy' }}</span>
          <span *ngIf="!data.newContractStartDate">-</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="meterZipCode">
        <th mat-header-cell *matHeaderCellDef>Meter Zip Code</th>
        <td class="inputCell" [ngStyle]="{ color: !data.validZipCode ? 'red' : 'black' }" mat-cell *matCellDef="let data">
          <div style="display: flex">
            <input
              matInput
              type="text"
              style="border: 0px; height: 100%"
              matTooltipClass="enable-line-break ud-tooltip"
              [matTooltip]="data.zipCodeError"
              (change)="setZipCodeValid($event.target.value, data)"
              value="{{ data.meterZipCode }}"
              [disabled]="isReadOnly"
            />
            <mat-spinner matSuffix [diameter]="16" *ngIf="lookingForZip" color="accent" [matTooltip]="'Searching Zipcode..'"></mat-spinner>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="uploadConsumption">
        <th mat-header-cell *matHeaderCellDef>
          Uploaded Usage<span style="text-transform: none">&nbsp;{{ utilityUOM$ | async | lowercase }}</span>
        </th>
        <td class="readOnlyCell" mat-cell *matCellDef="let data">
          <span>{{ data.uploadConsumption | number: '1.0-0' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="estimatedConsumption">
        <th mat-header-cell *matHeaderCellDef>Estimated Usage<wbr /> <span style="text-transform: none">&nbsp;(kWh/year)</span></th>
        <td class="readOnlyCell" mat-cell *matCellDef="let data">
          <span *ngIf="data.estimatedConsumption > 0">{{ data.estimatedConsumption | number: '1.0-0' }}</span>
          <mat-spinner
            matSuffix
            [diameter]="16"
            *ngIf="data.loadingLoadProfile"
            color="primary"
            [matTooltip]="'Fetching load profile.'"
          ></mat-spinner>
        </td>
      </ng-container>

      <ng-container matColumnDef="days">
        <th mat-header-cell *matHeaderCellDef>Days</th>
        <td class="readOnlyCell" mat-cell *matCellDef="let data">
          <span>{{ data.days }}</span>
          <span *ngIf="!data.days">-</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="consumptionStartDate">
        <th mat-header-cell *matHeaderCellDef>Usage Start Date</th>
        <td class="readOnlyCell" mat-cell *matCellDef="let data">
          <span>{{ data.consumptionStartDate | date: dateFormat }}</span>
          <span *ngIf="!data.consumptionStartDate">-</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="consumptionEndDate">
        <th mat-header-cell *matHeaderCellDef>Usage End Date</th>
        <td class="readOnlyCell" mat-cell *matCellDef="let data">
          <span>{{ data.consumptionEndDate | date: dateFormat }}</span>
          <span *ngIf="!data.consumptionEndDate">-</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="meterReadings">
        <th mat-header-cell *matHeaderCellDef>Meter Readings</th>
        <td class="readOnlyCell" mat-cell *matCellDef="let data">
          <span>{{ data.meterReadings }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="remove">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let data" style="width: 100px">
          <div class="delete-container button">
            <button
              class="delete-container-item white"
              mat-stroked-button
              color="accent"
              type="button"
              (click)="deleteUtilityAccount(data.utilityAccountNumber)"
              [disabled]="isReadOnly"
            >
              <mat-icon color="accent" matPrefix>delete</mat-icon>
              Delete
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </section>
</div>

<app-wizard-step-nav-buttons (backClicked)="back()" (nextClicked)="next()"></app-wizard-step-nav-buttons>
